// extracted by mini-css-extract-plugin
export default {"si_frame":"sisense_si_frame__ioLco"};